import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { get, omit } from 'lodash'

import { users } from '../redux'

import UsersList from '../components/UsersList'
import AccountSettingsForm from '../components/AccountSettingsForm'
import EmailPasswordResetForm from '../components/EmailPasswordResetForm'

const UsersContainer = ({ action, user }) => {
    switch (action) {
        case 'edit':
            return (
                <AccountSettingsForm initialValues={ omit(user, 'fcm_id') } />
            )
        case 'reset-password':
            return (
                <EmailPasswordResetForm initialValues={ user } />
            )
        default:
            return <UsersList />
    }
}

UsersContainer.propTypes = {
    action : PropTypes.string,
    user   : PropTypes.object
}

function mapStateToProps(state, ownProps) {
    const id = get(ownProps, 'match.params.id')
    return {
        action : get(ownProps, 'match.params.action'),
        user   : users.getForID(id)(state)
    }
}

export default connect(mapStateToProps)(UsersContainer)
